const overlayToggleSelector = '.js-overlay-toggle';

function initOverlays() {

  const overlayToggleElems = document.querySelectorAll(overlayToggleSelector);
  overlayToggleElems.forEach(toggleElem => {
    const overlayId = toggleElem.dataset.overlayId;
    if (overlayId) {
      const overlayElem = document.getElementById(overlayId);
      if (overlayElem) {
        toggleElem.addEventListener('click', event => {
          overlayElem.classList.toggle('is-active');
          document.body.classList.toggle('overlay-visible');
        });
      }
    }
  });

}

if(document.querySelector(overlayToggleSelector) !== null) {
  initOverlays();
}
